export default function(amount, options) {
  const allOptions = Object.assign(
    { includeZeros: true, includeEuro: true, zeroPadding: 0 },
    options
  );
  let formatted = '';
  const eurosAndCents = (amount.toFixed(2) + '').split('.');
  const euros = addZeroPadding(eurosAndCents[0], allOptions.zeroPadding);
  const cents = eurosAndCents[1];
  if (cents !== '00' || allOptions.includeZeros) {
    formatted = `${euros},${cents}`;
  } else {
    formatted = `${euros}`;
  }

  if (allOptions.includeEuro) {
    formatted += ' €';
  }
  return formatted;
}

function addZeroPadding(number, zeroPadding) {
  number = String(number);
  while (number.length < zeroPadding) {
    number = '0' + number;
  }
  return number;
}
